import styles from './Competitors.module.css'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { MapWithCompetitorsContainer } from './containers/MapWithCompetitorsContainer'
import { HostServicesListCardContainer } from './containers/HostServicesListCardContainer'
import { StartPropertySpyDialog } from './presentationals/StartPropertySpyDialog'
import classNames from 'classnames'
import { DateTime } from 'luxon'
import { useBreakpointUp} from 'shared/hooks/useBreakpointQueries'
import { HostServiceListLoadingDialog } from './presentationals/HostServiceListLoadingDialog'
import { ApplicationMainTabs } from 'shared/widgets/ApplicationMainTabs'
import { PropertySpyStopConfirmationDialog } from 'shared/widgets/PropertySpyStopConfirmationDialog'
import { ReadHostServiceListByMonitorIdParamsModel } from 'entities/hostService/api/types'
import { useStartSpyHostServiceMutation, useStopSpyHostServiceMutation } from 'entities/propertySpy/api/propertySpyApi'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { selectContextLocationSearchString, setMode, setNotificationsSettingsDialogOpen } from 'store/applicationSlice'
import { useReadUserSettingsQuery } from 'services/user'
import { useReadSpyCurrentLaunchDecorator } from 'shared/hooks/useReadSpyCurrentLaunchDecorator/useReadSpyCurrentLaunchDecorator'
import { useCreateOrReadSpy } from 'shared/hooks/useCreateOrReadSpy/useCreateOrReadSpy'
import { useSpyHasCompletedLaunches } from 'shared/hooks/useSpyHasCompletedLaunches'
import { HostServiceDialog } from 'shared/widgets/HostServiceDialog'
import { LocationHint } from './presentationals/LocationHint/LocationHint'
import { useReadHostServiceListByMonitorIdQuery } from 'services/hostService'
import { useReadMonitorByIdQuery } from 'services/monitor/qmonitor'
import { DefaultContextControl} from 'shared/widgets/DefaultContextControl'
import { CreateOrReadSpyParams } from 'shared/hooks/useCreateOrReadSpy/types'
import { useContextFilters } from 'shared/hooks/useContextFilters'
import { useContextSpyLaunchSettings } from 'shared/hooks/useContextSpyLaunchSettings1'
import { useContextLocation } from 'shared/hooks/useContextLocation'
import { useContextSpyId } from 'shared/hooks/useContextSpyId'
import { useContextManager } from 'shared/hooks/useContextManager'
import { MapBounds } from 'shared/types/MapBounds'
import { dbscanGeo } from 'shared/lib/dbscanGeo'
import { DefaultContextControlContainer } from 'shared/containers/DefaultContextControl/DefaultContextControlContainer'
import { useEventListener } from 'shared/providers/EventBusProvider'
import { useThrottle } from 'shared/hooks/useThrottle'
interface CompetitorsProps{
}

const DefaultReadHostServicesTimeout = 2200

export const Competitors = (props: CompetitorsProps): JSX.Element => {
    const {
    } = props

    const [readHostServicesTimeout, setReadHostServicesTimeout] = useState<number>(DefaultReadHostServicesTimeout)
    const [propertySpyStopConfirmationDialogOpen, setPropertySpyStopConfirmationDialogOpen] = useState<boolean>(false)
    const [stopSpyInformation, setStopSpyInformation] = useState<any>(undefined)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [startPropertySpyDialogOpen, setStartPropertySpyDialogOpen] = useState<boolean>(false)
    const [updateNeeded, setUpdateNeeded] = useState<boolean>(false) 
    const [isChecking, setIsChecking] = useState<boolean>(true)  
    const {createOrReadSpy} = useCreateOrReadSpy()
    const [attempts, setAttempts] = useState<number>(0)  
    const [startSpyHostService] = useStartSpyHostServiceMutation()
    const [stopSpyHostService] = useStopSpyHostServiceMutation()
    const isMediumScreenOrMore = useBreakpointUp('xl')
    const [selectedHostService, setSelectedHostService] = useState<any>(undefined)
    const [hostServiceDialogOpen, setHostServiceDialogOpen] = useState(false)
    const [mapBounds, setMapBounds] = useState<MapBounds | undefined>(undefined)
    const { spyHasCompletedLaunches } = useSpyHasCompletedLaunches()
    const dispatch = useAppDispatch()


 /////////////////////////////////////
    const locationString: any = useAppSelector(selectContextLocationSearchString)

    const {
        selectContextSpyId,
        setContextSpyId
    } = useContextSpyId()

    const {
        selectContextLocation,
        setContextLocation
    } = useContextLocation()

    const {
        selectContextSpyLaunchSettings,
        setContextSpyLaunchSettings
    } = useContextSpyLaunchSettings()

    const {
        selectContextFilters,
        setContextFilters
    } = useContextFilters()

    const search = async (params: any) => {    
        if (params.location === undefined && selectContextLocation === undefined){
            return
        }   

        const createOrReadSpyParams: CreateOrReadSpyParams = {
            location: params.location || selectContextLocation,
            filters: params.filters || selectContextFilters,
            launchSettings: params.spyLaunchSettings || selectContextSpyLaunchSettings
        }

        const createOrReadSpyResult: any = await createOrReadSpy(createOrReadSpyParams)
        const createOrReadSpySpyId =  createOrReadSpyResult?.id
        setContextSpyId(createOrReadSpySpyId)   
    }

    //////////////////////////
    const spyId = selectContextSpyId
    useEventListener('defaultContextControl:search', (params) => {
       search(params)
    })

    useEventListener('defaultContextControl:filtersChange', (params) => {
        search(params)
    })

    useEventListener('defaultContextControl:spyLaunchSettingsChange', (params) => {
        search(params)
    })

    //{useReadMonitorByIdQuery
    const [readMonitorByIdQueryParams, setReadMonitorByIdQueryParams] = useState<any>(undefined)
    const [readMonitorByIdOptions, setReadMonitorByIdOptions] = useState<any>(
        {
            skip: true
        }
    )

    const {
        data: readMonitorByIdQueryData,
        isLoading: readMonitorByIdQueryIsLoading
    } = useReadMonitorByIdQuery(readMonitorByIdQueryParams, readMonitorByIdOptions)

    useEffect(() => {
        setReadMonitorByIdQueryParams({
            monitorId: spyId 
        })
        setReadMonitorByIdOptions({
            skip: spyId === undefined
        })
    }, [
        spyId
    ])
    //useReadMonitorByIdQuery}
   
    const {
        data: readSpyCurrentLaunchDecoratorData,
        previousData: readSpyCurrentLaunchDecoratorPreviousData,
        setParams: setReadSpyCurrentLaunchDecoratorParams,
        setOptions: setReadSpyCurrentLaunchDecoratorOptions,
    } = useReadSpyCurrentLaunchDecorator()

    const [readHostServiceListByMonitorIdQueryParams, setReadHostServiceListByMonitorIdQueryParams] = useState<ReadHostServiceListByMonitorIdParamsModel>({
        monitorId: spyId || -1,
        //checkin: DateTime.now().plus({ days: 1 }).toSQLDate() ????
    })

    const [readHostServiceListByMonitorIdQueryOptions, setReadHostServiceListByMonitorIdQueryOptions] = useState<any>({
        skip: true,
        refetchOnMountOrArgChange: true,
    })

    const {
        data: readHostServiceListByMonitorIdQueryData,
        isFetching: readHostServiceListByMonitorIdQueryIsFetching,
        isLoading: readHostServiceListByMonitorIdQueryIsLoading,
        isError: readHostServiceListByMonitorIdQueryIsError,
        status: readHostServiceListByMonitorIdQuerystatus, 
        refetch: readHostServiceListByMonitorIdQueryRefetch,
        isUninitialized: readHostServiceListByMonitorIdQueryIsUninitialized
    } = useReadHostServiceListByMonitorIdQuery(readHostServiceListByMonitorIdQueryParams, readHostServiceListByMonitorIdQueryOptions)

    const {
        data: readUserSettingsData,
        isLoading: readUserSettingsIsLoading,
        isFetching: readUserSettingsIsFetching,
        error: readUserSettingsError,
        refetch
    } = useReadUserSettingsQuery(undefined)

    const competitorsContentClasses = classNames(styles.Competitors__Content, {
        [styles[`Competitors__Content--Empty`]]: readHostServiceListByMonitorIdQueryData === undefined
    })

    const handleStartPropertySpyDialogClose = (event: any) => {
        setStartPropertySpyDialogOpen(false)
    }

    const handleStartPropertySpyDialogOk = (event: any) => {
        setStartPropertySpyDialogOpen(false)
    }
    
    const handlePropertySpyStopConfirmationDialogCancel = () => {
        setPropertySpyStopConfirmationDialogOpen(false)
        setStopSpyInformation(undefined)
    }

    const handlePropertySpyStopConfirmationDialogOk = async () => {
        await stopSpyHostService({
            hostServiceId: stopSpyInformation.hostServiceId,
            marketSpyId: stopSpyInformation.spyId
        }) 

        if (readHostServiceListByMonitorIdQueryData !== undefined){
            readHostServiceListByMonitorIdQueryRefetch()
        }

        setStopSpyInformation(undefined)
        setPropertySpyStopConfirmationDialogOpen(false)
    }

    const startReadSpyStatus = async (spyId: number) => {
        setReadSpyCurrentLaunchDecoratorParams({
            spyId: spyId
        })

        setReadSpyCurrentLaunchDecoratorOptions({
            skip: false,

        })
    }

    const stopReadSpyStatus = async () => {
        setReadSpyCurrentLaunchDecoratorOptions({
            skip: true
        })
    }


    const checkNotifications = async () => {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration === undefined) {
            return false;
        }

        const subscribed = await registration.pushManager.getSubscription();
        if (subscribed) {
            return true;
        }

        return false
    }

    useEffect(() => {
        const handle  = async () => {
            if (spyId !== undefined){
                let needShow = false
                const res = await checkNotifications()

                if (readUserSettingsData !== undefined){
                    needShow = !res || !readUserSettingsData.emailNotificationsEnabled || !readUserSettingsData.whatsappNotificationsEnabled
                }

                if (needShow){
                    dispatch(setNotificationsSettingsDialogOpen(true))
                }
            }    
        }
        handle()
    }, [
        spyId,
        readUserSettingsData
    ])

    useEffect(() => {
        setAttempts(0)
    }, [
       spyId 
    ])

    useEffect(() => {
        const handle = async () => {
            if (spyId === undefined){
                stopReadSpyStatus()
                setIsChecking(true)
                return
            }

            setIsChecking(true)
            setIsLoading(true)
            startReadSpyStatus(spyId)

            const spyHasCompletedLaunchesResult = await spyHasCompletedLaunches(spyId)
            if (spyHasCompletedLaunchesResult === true){
                setReadHostServicesTimeout(1500)
                setUpdateNeeded(true)
            }

            setIsChecking(false)
        }

        handle()
    }, [
        spyId
    ])

    useEffect(() => {
        const handle = async () => {
            if (isChecking === true){
                return
            }
            
            if (updateNeeded === true){
                if (spyId === undefined){
                    return
                }

                if (readHostServiceListByMonitorIdQueryIsLoading === true){
                    setIsLoading(true)
                }

                setTimeout(() => {
                    setReadHostServicesTimeout(DefaultReadHostServicesTimeout)
                    setReadHostServiceListByMonitorIdQueryParams((prev: any) => {
                        return {
                            ...prev,
                            monitorId: spyId,
                            //...selectContextFilters
                        }
                    })

                    setReadHostServiceListByMonitorIdQueryOptions((prev: any) => {
                        return {
                            ...prev,
                            skip: !(updateNeeded && spyId !== undefined)
                        }
                    })

                    if (readHostServiceListByMonitorIdQueryIsUninitialized === false && readHostServiceListByMonitorIdQueryIsLoading === false){
                        readHostServiceListByMonitorIdQueryRefetch()
                    }
                }, readHostServicesTimeout)            
                setUpdateNeeded(false)
            }
        }
        handle()
    }, [
        updateNeeded, 
        spyId, 
        isChecking,
        readHostServiceListByMonitorIdQueryIsLoading
    ])

    useEffect(() => {
        const handle = () => {
            if (readSpyCurrentLaunchDecoratorData?.status === 2){
                setUpdateNeeded(true)
                return
            }

            if (readSpyCurrentLaunchDecoratorData?.status === 0 || readSpyCurrentLaunchDecoratorData?.status === 1){
                if (readSpyCurrentLaunchDecoratorData.completed > readSpyCurrentLaunchDecoratorPreviousData?.completed ) {
                    setUpdateNeeded(true)
                    return
                }

                if (readSpyCurrentLaunchDecoratorPreviousData?.completed > 0 && readSpyCurrentLaunchDecoratorData?.completed === 0){
                    setUpdateNeeded(true)
                    return
                }

                if (readSpyCurrentLaunchDecoratorPreviousData?.completed > 0 && readSpyCurrentLaunchDecoratorData?.completed === null){
                    setUpdateNeeded(true)
                    return
                }
                
            }
        }

        handle()
    }, [
        readSpyCurrentLaunchDecoratorData
    ])

    useEffect(()=> {
        if (readHostServiceListByMonitorIdQueryData === undefined){
            return
        }

        if (readHostServiceListByMonitorIdQuerystatus === 'pending'){
            return
        }

        if (readHostServiceListByMonitorIdQueryData.count === 0){
            if (attempts === 3){
                setIsLoading(false)
                return
            }  

            setAttempts((prev) => prev + 1)
            return
     
        }

        setIsLoading(false)
    }, [
       readHostServiceListByMonitorIdQuerystatus
    ])

    useEffect(() => {
        if (attempts > 0){
            setUpdateNeeded(true)
        }

    }, [
        attempts
    ])

    useEffect(() => {
        dispatch(setMode('property'))
    }, [])

    useEffect(() => {
        setUpdateNeeded(true)
    }, [
        selectContextFilters
    ])

    useEffect(() => {
        setIsLoading(false)
    }, [
        readHostServiceListByMonitorIdQueryIsError
    ])

    const handleSelectHostService = useCallback((event: any) => {
        const rank = readHostServiceListByMonitorIdQueryData?.list.findIndex((hostService: any) => hostService.id === event.id)
        
        setSelectedHostService({
            ...event,
            rank: rank + 1
        })

        if (isMediumScreenOrMore === false && event !== undefined){
            setHostServiceDialogOpen(true)
        }
    }, [
        isMediumScreenOrMore
    ])

    const handleMapWithCompetitorsSelectHostService = (event: any) => {
        handleSelectHostService(event)
    }

    const handleMapWithCompetitorsUnselectHostService = (event: any) => {
        setSelectedHostService(undefined)
    }

    const handleHostServiceDialogClose = () => {
         setHostServiceDialogOpen(false)
    }

    useEffect(() => {
        if (readHostServiceListByMonitorIdQueryData === undefined){
            return
        }

        if (selectedHostService === undefined){
            return
        }

        const rank = readHostServiceListByMonitorIdQueryData?.list.findIndex((hostService: any) => hostService.id === selectedHostService.id)
        if (rank === -1){
            return
        }

        const updSelected = readHostServiceListByMonitorIdQueryData?.list[rank]

        setSelectedHostService({
                ...updSelected,
                rank: rank + 1
            }
        )
    }, [
        readHostServiceListByMonitorIdQueryData
    ])

    const handleStartPropertySpy = useCallback(async (event: any) => {
        await startSpyHostService({
            hostServiceId: event.id,
            marketSpyId: spyId || -1
        })
        if (readHostServiceListByMonitorIdQueryData !== undefined){
            readHostServiceListByMonitorIdQueryRefetch()
        }

        setStartPropertySpyDialogOpen(true)
    }, [
        spyId,
        readHostServiceListByMonitorIdQueryData
    ])

    const handleStopPropertySpy = useCallback(async (event: any) => {
        setStopSpyInformation({
            hostServiceId: event.id,
            spyId: spyId || -1
        })
       
        setPropertySpyStopConfirmationDialogOpen(true)
    }, [
        spyId
    ]) 

    const throttledStMapBounds= useThrottle(
        (event: any) => {
            setMapBounds(event.detail.bounds)
        },
        200,
        { leading: true, trailing: true }
    );


    const handleMapWithCompetitorsMapBoundsChanged = (event: any) => {
        throttledStMapBounds(event)
    }

    const hostServicesReduced = useMemo(() => {
        function compare(a: any, b: any) {
            if (a.position < b.position) {
                return -1
            }

            if (a.position > b.position) {
                return 1
            }

            return 0
        }

        const hostServices = readHostServiceListByMonitorIdQueryData?.list
        if (hostServices === undefined){
            return []
        }

        const hostServicesWithIndex = hostServices.map((hostservice: any, index: number) => {
            return {
                ...hostservice,
                position: index+1
            }
        })
       
        const filteredHostServices:any = []
        const dbscanResult = dbscanGeo(hostServicesWithIndex, 2, 1)
        dbscanResult.clusters.forEach((cluster: any) => {
            const innerdbscanResult = dbscanGeo(cluster, 0.15, 1)

            innerdbscanResult.clusters.forEach((innerCluster: any) => {
                innerCluster.sort(compare)
                filteredHostServices.push(innerCluster[0])
            })
        })


        return filteredHostServices
    }, [
        readHostServiceListByMonitorIdQueryData
    ])
 
    const hostServicesFilteredByMapBounds = useMemo(() => {
        if (mapBounds === undefined && hostServicesReduced === undefined){
            return []
        }

        if (mapBounds === undefined && hostServicesReduced){
            return [...hostServicesReduced]
        }
        
        if (mapBounds !== undefined){
            const result: any = []
            hostServicesReduced.forEach((hostService: any) => {
                if (hostService.latitude < mapBounds.north 
                    && hostService.latitude > mapBounds.south 
                    && hostService.longitude > mapBounds.west
                    && hostService.longitude < mapBounds.east){
                        result.push(hostService)
                    }
            })

            return result
        }

        return []
    }, [
        mapBounds,
        hostServicesReduced
    ])

    return (
        <>
            <ApplicationMainTabs />
            <div className={competitorsContentClasses}>
                <div className={styles.Competitors__HostServicesListCardContainer}>
                    <HostServicesListCardContainer
                        mapBounds={mapBounds}
                        hostServices={readHostServiceListByMonitorIdQueryData?.list}
                        hostServicesReduced={hostServicesReduced}
                        hostServicesFilteredByMapBounds={hostServicesFilteredByMapBounds}
                        count={readHostServiceListByMonitorIdQueryData?.count}
                        spyId={spyId}
                        onStartPropertySpy={handleStartPropertySpy}
                        onStopPropertySpy={handleStopPropertySpy}
                        loading={isLoading}
                    />
                </div>
                <div className={styles.Competitors__MapWithCompetitorsContainer}>
                    <MapWithCompetitorsContainer
                        location={selectContextLocation}
                        hostServices={readHostServiceListByMonitorIdQueryData?.list}
                        selectedHostService={selectedHostService}
                        hostServicesFilteredByMapBounds={hostServicesFilteredByMapBounds}
                        count={readHostServiceListByMonitorIdQueryData?.count}
                        spyId={spyId}
                        onStartPropertySpy={handleStartPropertySpy}
                        onStopPropertySpy={handleStopPropertySpy}
                        onSelectHostService={handleSelectHostService}
                        onUnselectHostService={handleMapWithCompetitorsUnselectHostService}
                        onMapBoundsChanged={handleMapWithCompetitorsMapBoundsChanged}
                        loading={isLoading}
                    />
                    {
                        selectContextLocation === undefined && (<div className={styles.LocationHintContainer}>
                            <LocationHint/>
                        </div>)
                    }           
                </div>
            </div> 
            <StartPropertySpyDialog
                open={startPropertySpyDialogOpen}
                onClose={handleStartPropertySpyDialogClose}
                onOk={handleStartPropertySpyDialogOk}
            />
            <HostServiceListLoadingDialog
                open={isLoading}
            />
            <PropertySpyStopConfirmationDialog 
                open={propertySpyStopConfirmationDialogOpen}
                keepMounted={false}
                onCancel={handlePropertySpyStopConfirmationDialogCancel}
                onOk={handlePropertySpyStopConfirmationDialogOk}      
            />
            <HostServiceDialog 
                open={hostServiceDialogOpen}
                hostService={selectedHostService}
                spyId={spyId}
                onClose={handleHostServiceDialogClose}
                onOk={handleHostServiceDialogClose}
                onStartPropertySpy={handleStartPropertySpy}
                onStopPropertySpy={handleStopPropertySpy}
            />
            <DefaultContextControlContainer
            />
        </>         
    )
}